import PageLayout from '@components/PageLayout';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@puppet/react-components';
import Breadcrumbs, {
  BreadcrumbsType,
} from '@components/Breadcrumbs/Breadcrumbs';
import RootAccountsTable from '@views/RootAccounts/components/RootAccountsTable';

const RootAccounts = () => {
  const { t } = useTranslation('codeDelivery');

  const breadcrumbs: BreadcrumbsType = [
    {
      displayName: t('root.accounts.breadcrumbs.root.console'),
    },
    {
      displayName: t('root.accounts.breadcrumbs.root.accounts'),
    },
  ];

  return (
    <PageLayout className="root-accounts-page">
      <PageLayout.Header>
        <PageLayout.Breadcrumbs>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </PageLayout.Breadcrumbs>
        <Heading>{t('root.accounts.header')}</Heading>
      </PageLayout.Header>
      <PageLayout.Content>
        <RootAccountsTable />
      </PageLayout.Content>
    </PageLayout>
  );
};

export default RootAccounts;
